import { connect } from 'react-redux';
import { withLastLocation } from 'react-router-dom-last-location';
import AdvisorCTA from './advisor_cta';
import { makeCallOrShowPopup } from '../../../../actions/voip_chat';
import { startChat, chatInit } from '../../../../actions/chat';
import { authPendingAction, displayRegister } from '../../../../actions/auth';
import withPGTranslation from '../../../../config/withPGTranslation';
import { advisorCtaThemes } from './advisor_cta_themes';
import { getUserFirstActivePromotion } from  '../../../../config/util';

const mapStateToProps = (
  { advisors, user, application },
  { advisorId, theme }
) => ({
  ...((advisors || {})[parseInt(advisorId, 10)] || {}),
  theme: theme || advisorCtaThemes.default,
  userXfmProgram: user?.user?.xfmProgram,
  userAdvisorModeSalePrice: getUserFirstActivePromotion({ user, application })?.advisorModeSalePrice,
  currency: user?.user?.currency || application?.dynamicConfig?.currency,
  fxRate: user?.user?.fxRate || application?.dynamicConfig?.fxRate
});

export default connect(
  mapStateToProps,
  {
    startChat,
    authPendingAction,
    displayRegister,
    makeCallOrShowPopup,
    chatInit
  }
)(withLastLocation(withPGTranslation(AdvisorCTA)));
